export const priorities = [
  { id: "1", value : "Low" },
  { id: "2", value : "Medium" },
  { id: "3", value : "High" },
]
